import { getFeatureData } from 'config-request';
import { CategoryCode, FeatureType, SubCategoryCode, } from 'config-request/src/interfaces/feature-list';
import { defineStore } from 'pinia';
import { useOptionImageStore } from './option-image';
import { useFeatureListStore } from './feature-list';
import { usePriceListStore } from './price-list';
export const useAdditionalStore = defineStore('additional', {
    state() {
        return {
            optionImgMap: {},
        };
    },
    getters: {
        /**
         * 核心标配列表
         */
        additionalList() {
            const featureListStore = useFeatureListStore();
            const optionImageStore = useOptionImageStore();
            const priceList = usePriceListStore();
            if (!featureListStore.data)
                return [];
            const additionalCodeList = [
                CategoryCode.Additional,
                SubCategoryCode.SubAdditional,
                FeatureType.SubAdditional,
            ];
            const featureItem = getFeatureData(additionalCodeList, featureListStore.data);
            return featureItem?.option_list?.map((option) => {
                const item = featureListStore.data?.option_map[option];
                const priceDiscountTip = priceList.data?.configurator_select_discount_tip_map?.[option] || '';
                const discountData = {
                    discount_selected: !!priceDiscountTip,
                    discount_tip: priceDiscountTip || item?.discount_tip || '',
                };
                const material = optionImageStore.commonImgs(SubCategoryCode.SubAdditional, item?.code ?? '')?.[0];
                if (item?.code) {
                    this.optionImgMap[item?.code] = material;
                }
                return {
                    ...item,
                    imgSrc: material,
                    ...discountData,
                };
            });
        },
    },
});
